import {
  GET_SINGLE_PRODUCT,
  PRODUCTS_LOADING,
  PRODUCTS_ERROR,
} from "ActionTypes";

const initialState = {
  singleProduct: {},
  loading: false,
  error: {},
};

const AttributesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SINGLE_PRODUCT:
      return {
        ...state,
        loading: false,
        singleProduct: action.payload,
      };
    case PRODUCTS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case PRODUCTS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default AttributesReducer;
